
export class DataUtil {

  public static newDateOnly (dateString: any) {
    if (typeof dateString === 'string') {
      const civil = DataUtil.dataCivil(dateString);
      if (civil) return civil;
    }

    const data = new Date(dateString);

    return new Date(data.getUTCFullYear(), data.getUTCMonth(), data.getUTCDate());
  }

  /**
   * Data civil (nascimento, óbito...) como meia-noite local. Strings são lidas
   * pelos 10 primeiros caracteres (yyyy-MM-dd), ignorando horário e fuso: o back
   * manda "yyyy-MM-ddT00:00:00.000+00:00" e new Date(iso) cai no dia anterior
   * em UTC−3. Date é reduzido à data local.
   */
  public static dataCivil(valor: string | Date | null | undefined): Date | null {
    if (!valor) return null;

    if (valor instanceof Date) {
      return isNaN(valor.getTime()) ? null : new Date(valor.getFullYear(), valor.getMonth(), valor.getDate());
    }

    const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(valor));
    if (!m) return null;

    return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
  }

  /** dd/MM/yyyy de uma data civil, ou '' quando não há data válida. */
  public static formatarDataCivil(valor: string | Date | null | undefined): string {
    const data = DataUtil.dataCivil(valor);
    if (!data) return '';

    const dia = String(data.getDate()).padStart(2, '0');
    const mes = String(data.getMonth() + 1).padStart(2, '0');
    return `${dia}/${mes}/${data.getFullYear()}`;
  }

  public static formatarDataMesAno(dataISO: string | Date | undefined): string {
    if (!dataISO) return 'N/A';
  
    const data = new Date(dataISO);
    if (isNaN(data.getTime())) return 'N/A';
  
    const mes = String(data.getMonth() + 1).padStart(2, '0');
    const ano = data.getFullYear();
  
    return `${mes}/${ano}`;
  }

  public static formatarDataCompleta(dataISO: string | Date | undefined): string {
    if (!dataISO) return 'N/A';
  
    const data = new Date(dataISO);
    if (isNaN(data.getTime())) return 'N/A';
  
    const dia = String(data.getDate()).padStart(2, '0');
    const mes = String(data.getMonth() + 1).padStart(2, '0');
    const ano = data.getFullYear();
  
    return `${dia}/${mes}/${ano}`;
  }

  public static getDiasEntreDatas(dataInicio : Date, dataFim : Date): number {
    const inicio = new Date(dataInicio);
    const fim = new Date(dataFim);

    const diff = Math.ceil((fim.getTime() - inicio.getTime()) / (1000 * 60 * 60 * 24)) + 1;

    return diff;
  }

  
}